import React, { useEffect, useState } from "react";
import { ScenarioDto } from "../Types/types";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import AddChildDialog from "./ScenarioDialog";
import { Button } from "@mui/material";
import { createScenariosApi, deleteScenarioApi, getScenariosApi, updateScenarioApi } from "../../../Services/Admin/ScenarioServices";

// const initialRows: ScenarioDto[] = [
//     { id: 1, name: "Parent A" },
//     { id: 2, name: "Parent B" },
// ];

const initialForm: ScenarioDto = {
    title: "",
    guardian: "",
    question: "",
    hint: "",
    text: ""
}

const ScenariosList = () => {
    const [rows, setRows] = useState<ScenarioDto[]>([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [formCreateData, setFormCreateData] = useState<ScenarioDto>(initialForm);
    const [type, setType] = useState<string>("");

    const handleAddNew = () => {
        setType("Add");
        console.log(type);
        setFormCreateData(initialForm);
        setDialogOpen(true);
    };

    const handleEdit = (row: any) => {
        console.log(row);
        setType("Edit");
        console.log(type);
        setFormCreateData(() => ({ ...row }));
        setDialogOpen(true);
    };

    const handleDelete = async (id: number) => {
        const result = await deleteScenarioApi(id);
        if (result) {
            const newRows = rows.filter(x => x.id !== id);
            setRows(newRows)
        }
    };

    const handleChangeCreateForm = (value: any, field: string) => {
        setFormCreateData(prev => ({ ...prev, [field]: value }))
    }

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleSave = async (type: string) => {
        if (type === "Add") {
            const result = await createScenariosApi(formCreateData);
            console.log("Saved child:", result);
            setRows((prev) => ([result.data, ...prev]));
            setDialogOpen(false);
        }
        else {
            const result = await updateScenarioApi(formCreateData);
            console.log("Saved child:", result);

            const newData = [...rows];
            const index = newData.findIndex(x=>x.id === formCreateData.id);
            newData[index] = {...result.data};

            setRows((prev) => ([...newData]));
            setDialogOpen(false);
        }

    };

    useEffect(() => {
        getScenariosApi().then(res => {
            setRows(res.data);
        });
    }, []);

    const columns: GridColDef[] = [
        { field: "id", headerName: "ID", width: 90 },
        { field: "title", headerName: "title", width: 200 },
        { field: "guardian", headerName: "guardian", width: 200 },
        { field: "question", headerName: "question", width: 200 },
        { field: "hint", headerName: "hint", width: 200 },
        { field: "text", headerName: "text", width: 200 },
        { field: "rootOptionId", headerName: "rootOptionId", width: 200 },
        {
            field: "actions",
            headerName: "Actions",
            width: 300,
            renderCell: (params: GridRenderCellParams) => (
                <>
                    <Button
                        variant="contained"
                        onClick={() => handleEdit(params.row)}>
                        Edit
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => handleDelete(params.row.id)}>
                        Delete
                    </Button>
                </>
            ),
        },
    ];

    return (
        <>
            <h2>Scenarios Grid</h2>
            <div style={{ height: 400, width: "100%" }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    slots={{
                        toolbar: () => <Button variant="contained" sx={{ width: "10%" }}
                            onClick={() => handleAddNew()}
                        >Add New</Button>
                    }}
                    showToolbar
                />
            </div>
            <AddChildDialog
                open={dialogOpen}
                formData={formCreateData}
                onChange={handleChangeCreateForm}
                onClose={handleCloseDialog}
                onSave={handleSave}
                type={type}
            />
        </>
    );
};

export default ScenariosList;
